import { ICustomer } from 'app/shared/model/customer.model';
import { Role } from 'app/shared/model/enumerations/role.model';

export interface ILogin {
  id?: number;
  username?: string | null;
  role?: keyof typeof Role | null;
  customer?: ICustomer | null;
}

export const defaultValue: Readonly<ILogin> = {};
